<template>
    <div v-if="currentFilter && currentFilter.filterName" style="display: inline; color: #673AB7;">
        - {{currentFilter.filterName}}
    </div>
</template>

<script>
 export default {
    name: 'Filtername',
    props: {
      currentFilter: {
        type: Object,
        rquired: true,
        default: () => {{}}
      }
    },
    created() {
    },
    data() {
      return {
      }
    },
    methods: {
    }
  };
</script>
